// src/components/FaqSection.jsx
import React, { useState } from "react";
import "./FaqSection.css";

const faqs = [
  {
    question: "De quoi ai-je besoin pour louer une voiture ?",
    answer:
      "Vous aurez besoin d’un permis de conduire valide, d'une pièce d'identité et d'une carte de paiement.",
  },
  {
    question: "Quel est l'âge requis pour louer un véhicule ?",
    answer: "L'âge minimum est généralement de 21 ans, avec 2 ans de permis.",
  },
  {
    question: "Puis-je réserver une voiture de location pour quelqu'un d'autre ?",
    answer:
      "Oui, vous pouvez réserver pour un tiers, à condition de fournir ses informations et documents.",
  },
  {
    question: "Comment puis-je trouver la location de voiture la moins chère ?",
    answer:
      "Comparez les modèles, louez à l’avance et vérifiez les offres sur notre plateforme.",
  },
  {
    question:
      "À quoi dois-je donner la priorité lorsque je choisis une voiture ?",
    answer:
      "Considérez le confort, la consommation de carburant et le nombre de passagers/bagages.",
  },
  {
    question: "Tous les frais sont-ils inclus dans le prix de location ?",
    answer:
      "La plupart des frais sont inclus, mais des options comme l’assurance ou la livraison peuvent être en supplément.",
  },
];

export default function FaqSectionL() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section container my-5">
      <div className="card p-4 shadow-sm">
        <h4 className="fw-bold mb-4">📚 Questions fréquentes</h4>
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item border-top py-3">
            <div
              className="d-flex justify-content-between align-items-center pointer"
              onClick={() => toggle(index)}
            >
              <strong>{faq.question}</strong>
              <span>{openIndex === index ? "▲" : "▼"}</span>
            </div>
            {openIndex === index && (
              <div className="mt-2 text-muted">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
